export enum PaymentType {
    ABO_DIRECTDEBIT = "ABO_DIRECTDEBIT",
    // Fallback payments types
    ABO_BANKTRANSFER = "ABO_BANKTRANSFER",
    ABO_CREDITCARD = "ABO_CREDITCARD",
    ABO_BARZAHLEN = "ABO_BARZAHLEN",
    ABO_PAYPAL = "ABO_PAYPAL",
}
